import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Banner from "../components/banner/banner";
import Section01 from "../components/sec01/sec";
import Section02 from "../components/sec02/sec";
import Section03 from "../components/sec03/sec";
import Section04 from "../components/sec04/sec";
import Section05 from "../components/sec05/sec";
import AppsSection from "../components/appssection";

const Home = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const el = document.querySelector(hash);
        el?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, [hash]);

  return (
    <>
      <Banner />
      <Section01 />
      <Section02 />
      <Section05 />
      <Section03 />
      {/* <Section04/> */}
      <AppsSection />
    </>
  );
};

export default Home;
